<template>
  <div>
    <span class="sm-notification__inner">
      <include-svg :name="'icon-warning'" />
      <span>You haven't signed USPS Form 1583</span>
      <a
        href="#"
        class="sm-txt-strong"
        @click.prevent="openNotaryService"
      >Sign now</a>
    </span>
  </div>
</template>

<script>
import IncludeSvg from '@/components/IncludeSvg.vue';
import Btn from '@/components/Buttons.vue';
import Urls from '@/settings/urls';

export default {
  name: 'form-1583-notification',
  components: {
    "include-svg": IncludeSvg,
    "btn-block": Btn,
  },
  methods: {
    openNotaryService() {
      // window.open(Urls.external.notary_service, '_blank', {width: '100%'});
      this.$router.push('/customer/account?notarize=1');
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;

  .sm-notification__inner {
    display: flex;
    align-items: center;
    justify-content: center;

    @include media('<=tiny') {
      flex-wrap: wrap;
    }

    & > svg {
      margin-right: 5px;
    }

    & > a {
      display: flex;
      margin-left: 25px;
      padding: 2px 8px;
      color: var(--text);
      background-color: var(--yellow-2);
      border-radius: 4px;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.6;
      }

      @include media('<=tiny') {
        justify-content: center;
        width: 100%;
        margin-left: 0;
        margin-top: 5px;
        text-align: center;
      }
    }
  }
</style>